import React from 'react';
import {  DateInput,Responsive,SimpleList,NumberField,DateField,Show,ShowButton,List, TextField, SimpleShowLayout,ReferenceInput,Filter,SelectInput,FunctionField } from 'admin-on-rest/lib/mui';

import Datagrid from './Datagrid';
const dateFormatter = v => {
  // v is a string of "YYYY-MM-DD" format
  const match = /(\d{4})-(\d{2})-(\d{2})/.exec(v);
  if (match === null) return;
  const d = new Date(match[1], parseInt(match[2])-1, match[3]);
  if (isNaN(d)) return;
  return d;
};

const dateParser = v => {
  // v is a `Date` object
  if (!(v instanceof Date) || isNaN(v)) return;
  const pad = '00';
  const yy = v.getFullYear().toString();
  const mm = ((v.getMonth() + 1).toString());
  const dd = v.getDate().toString();
  return `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`;
};

var minDate=new Date();
minDate.setDate(minDate.getDate()-180);

const ZikuyimMonthFilter = (props) => (
    
    <Filter {...props} >
         <ReferenceInput label="בית עסק" source="id" reference="customers" perPage={500} sort={{ field: 'name_heb', order: 'ASC' }} allowEmpty>
            <SelectInput optionText="name_heb" />
        </ReferenceInput>
        <DateInput  format={dateFormatter} parse={dateParser} locales="he-IL" label="ת.סיום" source="EndDate" options={{
    mode: 'landscape',
    maxDate: new Date(),
  minDate:minDate,
    okLabel: 'אישור',
    
    cancelLabel: 'ביטול',
    locale: 'he'
}}/>
      <DateInput  format={dateFormatter} parse={dateParser} locales="he-IL" label="ת.התחלה" source="StartDate" options={{
    mode: 'landscape',
    maxDate: new Date(),
  minDate:minDate,
    okLabel: 'אישור',
    
    cancelLabel: 'ביטול',
    locale: 'he'
}}/>
        
    
    </Filter>
);


const rowStyle = (record) => {
    if (record.commission_ammount <0) return { backgroundColor: '#fdd' };
    
    return {};
};


export const ZikuyimMonthList1 = (props) => (
    <div>
    <List title="דף חשבון" perPage={30} {...props}  filters={<ZikuyimMonthFilter /> }>
     
      <Responsive
       small={
        
                 <Datagrid  rowStyle={rowStyle} bodyOptions={{showRowHover: true }}>
            
<TextField label="#" source="id" />

<DateField label="תאריך הפקדה" source="hafkada_date.date" locales="he-IL"/>
<DateField label="תאריך עסקה" source="iska_date.date" locales="he-IL"/>
<DateField label="תאריך זיכוי" source="zikui_date.date" locales="he-IL" />
<TextField label="סוג עסקה" source="tnuaa_type" />


<NumberField label="סכום עסקה" source="schum_iska" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
<NumberField label="סכום ברוטו לזיכוי" locales="he-IL" source="zikui_total_bruto" options={{ style: 'currency', currency: 'ILS' }}/>

<NumberField label="עמלה" style={{overflow:'visible '}} source="commission_ammount" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>
<NumberField label="עמלה + מעמ"  style={{overflow:'visible '}} source="commission_ammount_vat" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
<NumberField label="סכום נטו לזיכוי" style={{overflow:'visible '}} source="neto_zicui" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>

<TextField label="מספר ריכוז" source="rikuz_number" />
<TextField label="כ.א 4 ספרות" source="cc_id" />

    

    
            <ShowButton />
        </Datagrid>
            }
 medium={

            
    
            
        
          <Datagrid  rowStyle={rowStyle} bodyOptions={{showRowHover: true }}>
            
<TextField label="#" source="id" />

<DateField label="תאריך הפקדה" source="hafkada_date.date" locales="he-IL"/>
<DateField label="תאריך עסקה" source="iska_date.date" locales="he-IL"/>
<DateField label="תאריך זיכוי" source="zikui_date.date" locales="he-IL" />
<TextField label="סוג עסקה" source="tnuaa_type" />


<NumberField label="סכום עסקה" source="schum_iska" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
<NumberField label="סכום ברוטו לזיכוי" locales="he-IL" source="zikui_total_bruto" options={{ style: 'currency', currency: 'ILS' }}/>

<NumberField label="עמלה" style={{overflow:'visible '}} source="commission_ammount" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>
<NumberField label="עמלה + מעמ"  style={{overflow:'visible '}} source="commission_ammount_vat" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
<NumberField label="סכום נטו לזיכוי" style={{overflow:'visible '}} source="neto_zicui" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>

<TextField label="מספר ריכוז" source="rikuz_number" />
<TextField label="כ.א 4 ספרות" source="cc_id" />

    
 
    
            <ShowButton />
        </Datagrid>
        
        
 }
         />
  
    </List>
  
    </div>
);


const ZikuyimMonthTitle = ({ record }) => {
    return <span>מספר {record ? `"${record.id}"` : ''}</span>;
};

const ZikuyimMonthListTitle = ({ lst }) => {
    return <span>דף חשבון</span>;
};


export const ZikuyimMonthList = props => (
    <List title="דף חשבון - זיכויים" perPage={30} {...props}  filters={<ZikuyimMonthFilter /> }>
        <Datagrid  rowStyle={rowStyle} bodyOptions={{showRowHover: true }} totalRows="300">
            
<TextField label="#" source="id" />

<DateField label="תאריך הפקדה" source="hafkada_date.date" locales="he-IL"/>
<DateField label="תאריך העברה לבנק" source="bank_haavara_date.date" locales="he-IL"/>
<DateField label="תאריך עסקה" source="iska_date.date" locales="he-IL"/>
<DateField label="תאריך זיכוי" source="zikui_date.date" locales="he-IL" />
<TextField label="סוג עסקה" source="tnuaa_type"  />

<FunctionField label="סכום עסקה" source="schum_iska" render={record =>record.schum_iska.toLocaleString(undefined, {
                        style: 'currency',
                        currency: record.currency,
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })}/>
<NumberField label="סכום ברוטו לזיכוי" locales="he-IL" source="zikui_total_bruto" options={{ style: 'currency', currency: 'ILS' }}/>

<NumberField label="עמלה" style={{overflow:'visible '}} source="commission_ammount" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>
<NumberField label="עמלה + מעמ"  style={{overflow:'visible '}} source="commission_ammount_vat" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
<NumberField label="סכום נטו לזיכוי" style={{overflow:'visible '}} source="neto_zicui" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>

<TextField label="מספר ריכוז" source="rikuz_number" />
<TextField label="כ.א 4 ספרות" source="cc_id" />

    
 
    
            <ShowButton />
        </Datagrid>
        
    </List>
);





const ZikuyimMonthStyle = {
  width:120,
    minHeight: 40,
    marginLeft: '2em',
    display: 'inline-block',
    verticalAlign: 'top'
};



export const ZikuyimMonthShow = (props) => (

<Show title={<ZikuyimMonthTitle />} {...props}>
 <SimpleShowLayout >
  <TextField style={ZikuyimMonthStyle}  label="#" source="id" />
<TextField style={ZikuyimMonthStyle}  label="מזהה רשת חיצוני" source="external_id" />

<TextField style={ZikuyimMonthStyle} label="מספר בית עסק" source="buisiness_id" />
<TextField style={ZikuyimMonthStyle} label="מספר כרטיס מלא" source="cc_id" />

<TextField style={ZikuyimMonthStyle}  elStyle={{ width: '5em' }} label="מספר שובר" source="shovar_number" />
<TextField style={ZikuyimMonthStyle} label="סוג תנועה" source="tnuaa_type" />
<TextField style={ZikuyimMonthStyle} label="מקור  תנועה" source="tnuaa_source" />
<DateField style={ZikuyimMonthStyle} label="תאריך הפקדה" source="hafkada_date.date" />
<DateField style={ZikuyimMonthStyle} label="תאריך העברה לבנק" source="bank_haavara_date.date" />


<DateField style={ZikuyimMonthStyle} label="תאריך זיכוי" source="zikui_date.date" />
<TextField style={ZikuyimMonthStyle} label="מספר חשבון" source="account_number" />
<TextField style={ZikuyimMonthStyle} label="מטבע תנועה" source="tnuaa_currency" />
<TextField style={ZikuyimMonthStyle} label="מטבע זיכוי" source="zikui_currency" />
<TextField style={ZikuyimMonthStyle} label="אינדיקציה לתשלומים" source="payments_indication" />
<TextField style={ZikuyimMonthStyle} label="סכום עסקה  ברוטו תשלומים" source="bruto_iska_tashlumim" />
<TextField style={ZikuyimMonthStyle} label="סכום ברוטו לזיכוי " source="zikui_total_bruto" />
<TextField style={ZikuyimMonthStyle} label="סכום עמלה" source="commission_ammount" />
<TextField style={ZikuyimMonthStyle} label="מעמ עמלה" source="comission_vat" />
<TextField style={ZikuyimMonthStyle} label="סכום ההנחה" source="discount_ammount" />
<TextField style={ZikuyimMonthStyle} label="סכום זיכוי" source="total_zikui" />
<TextField style={ZikuyimMonthStyle} label="מספר תשלום נוכחי" source="current_payment_number" />
<TextField style={ZikuyimMonthStyle} label="מספר תשלומים" source="total_payments" />
<TextField style={ZikuyimMonthStyle} label="יתרת תשלומים" source="remaining_payments" />
<TextField style={ZikuyimMonthStyle} label="סכום ריבית דמי ניכיון" source="total_dme_nikayon_interest" />
<TextField style={ZikuyimMonthStyle} label="סכום דמי ניהול " source="total_dme_nihul" />
<TextField style={ZikuyimMonthStyle} label="ניקוד ב- pos" source="pos_points" />

<TextField style={ZikuyimMonthStyle} label="מספר מסוף" source="masof_number" />
<TextField style={ZikuyimMonthStyle} label="תש' ראשון" source="first_payment" />
<TextField style={ZikuyimMonthStyle} label="סכום תשלום" source="total_ammount" />
<TextField style={ZikuyimMonthStyle} label="מועדון" source="club" />

<TextField style={ZikuyimMonthStyle} label="קוד אישור" source="kod_ishur" />
<TextField style={ZikuyimMonthStyle} label="קוד מאפיין  עסקה" source="kod_meafyen_iska" />
<TextField style={ZikuyimMonthStyle} label="קוד אופי עסקה" source="kod_ofi_iska" />
<TextField style={ZikuyimMonthStyle} label="מזהה חד ערכי" source="unique_id" />
<TextField style={ZikuyimMonthStyle} label="סכום ביטול" source="bitul_ammount" />
<TextField style={ZikuyimMonthStyle} label="סכום עצירה" source="stop_ammount" />
<TextField style={ZikuyimMonthStyle} label="מזהה תנועה" source="tnuaa_id" />
<TextField style={ZikuyimMonthStyle} label="מהות עסקה" source="mahut_iska" />
<TextField style={ZikuyimMonthStyle} label="שער המרה" source="shaar_hamara" />
<TextField style={ZikuyimMonthStyle} label="שדה Z" source="z_field" />
<TextField style={ZikuyimMonthStyle} label="מזדמנת כ/ל" source="mizdamenet" />
<TextField style={ZikuyimMonthStyle} label="סטטוס רשומה 1/2" source="status_reshuma" />
<TextField style={ZikuyimMonthStyle} label="שם בית עסק" source="shem_esek" />
<TextField style={ZikuyimMonthStyle} label="מספר חשבון" source="mispar_cheshbon" />
<TextField style={ZikuyimMonthStyle} label="מזהה תוכנית כאל לקבל יותר" source="mezahe_tochnit_cal_yoter" />
<TextField style={ZikuyimMonthStyle} label="סכום הנחת כאל לקבל יותר" source="hanacha_cal_yoter" />
<TextField style={ZikuyimMonthStyle} label="אחוז הנחת כאל לקבל יותר" source="ahuz_hanacha_cal_yoter" />
<TextField style={ZikuyimMonthStyle} label="Mid Trn ID" source="mid_trn_id" />
<TextField style={ZikuyimMonthStyle} label="PSP Trn ID" source="psp_trn_id" />
<TextField style={ZikuyimMonthStyle} label="Gateway Trn ID" source="gateway_trn_id" />
<TextField style={ZikuyimMonthStyle} label="מזהה בקשת אישור" source="mezahe_bakasha_ishur" />

<TextField style={ZikuyimMonthStyle} label="מספר חשבונית" source="mispar_cheshbonit" />
<TextField style={ZikuyimMonthStyle} label="מספר משלם" source="mispar_meshalem" />
<TextField style={ZikuyimMonthStyle} label="סוג תנועה שבא" source="sug_tnuaa_shva" />
<TextField style={ZikuyimMonthStyle} label="סכום מזומן CASHBACK" source="mezuman_schum_cashback" />
<TextField style={ZikuyimMonthStyle} label="מזהה עסקה שבא" source="mezahe_iska_shva" />
<TextField style={ZikuyimMonthStyle} label="אינדיקציה לתייר" source="tayar_indikazia" />
<TextField style={ZikuyimMonthStyle} label="קובץ מקור" source="source_file" />

         </SimpleShowLayout>
    </Show>
);






























// WEBPACK FOOTER //
// ./src/components/ZikuyimMonth/zikuyimMonth.js